import * as ActionTypes from './../constants';

export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_GET_SOURCE_FILES_WITH_JW_MEDIA_ID : 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null, 
                response: null
            }
        case ActionTypes.RECEIVED_GET_SOURCE_FILES_WITH_JW_MEDIA_ID : 
            return {
                ...state,
                loading: false,
                response: action.res,
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID: 
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID: 
            return { }
        default :  return state
    }

}

 